import {inject, Injectable} from '@angular/core';
import {FormArray, FormGroup, UntypedFormArray, UntypedFormGroup, AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable()
export class ValidationService {

  constructor(private domSanitizer: DomSanitizer) {
  }

  public validateForm(formGroup: UntypedFormGroup, validationMessages: any): void {
    for (const validationMessage in validationMessages) {
      const splitedMessage = validationMessage.split('.');
      if (splitedMessage.length > 1) {
        this.getValidationControlFromArray(formGroup, validationMessage)!.setErrors(validationMessages[validationMessage]);
      } else {
        if (formGroup.controls[validationMessage]) {
          formGroup.controls[validationMessage].setErrors(validationMessages[validationMessage]);
        }
      }
    }
  }

  public validateFormForToastr(formGroup: UntypedFormGroup, validationMessages: any): string {
    let errores = '<div>';
    for (const validationMessage in validationMessages) {
      const splitedMessage = validationMessage.split('.');
      if (splitedMessage.length > 1) {
        errores += '<div>' + validationMessages[validationMessage] + '</div>';
      } else {
        if (formGroup.controls[validationMessage]) {
          errores += '<div>' + validationMessages[validationMessage] + '</div>';
        }
      }
    }
    errores += '</div>';
    return this.domSanitizer.bypassSecurityTrustHtml(errores) as string;
  }

  public jsonValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Si está vacío, no validamos JSON
      }

      try {
        JSON.parse(control.value);
        return null; // JSON válido
      } catch (error) {
        return { invalidJson: { message: 'El formato JSON no es válido' } };
      }
    };
  }

  public validateJsonAndParse(jsonString: string): { isValid: boolean; parsed?: any; error?: string } {
    if (!jsonString) {
      return { isValid: false, error: 'JSON vacío' };
    }

    try {
      const parsed = JSON.parse(jsonString);
      return { isValid: true, parsed };
    } catch (error) {
      return { isValid: false, error: error instanceof Error ? error.message : 'Error desconocido' };
    }
  }

  private getValidationControlFromArray(formGroup: UntypedFormGroup, validationMessage: string): FormGroup<any> | FormArray<any> | undefined {
    const splitedMessage = validationMessage.split('.');
    const abstractControl = formGroup.get(splitedMessage[0]) as UntypedFormArray;
    if (abstractControl instanceof UntypedFormGroup) {
      return (abstractControl).get(splitedMessage[1]) as UntypedFormGroup;
    }
    if (abstractControl instanceof UntypedFormArray) {
      return (abstractControl.at(Number(splitedMessage[1]))).get(splitedMessage[2]) as UntypedFormArray;
    }
    return undefined;
  }
}
